import Axios from 'axios';
import router from '@/router/index'

const https = require('https');
var config = require('./../clientconfig.json')
var pages = require('./../constantsreq').PAGES

var currentColoredElements = [];

export default {
    async postData (data, path="") {
        data.data.session=this.getCookie("session");
        data.data.userid=this.getCookie("userid");
        data.data.user=this.getCookie("user");
        data.data.sessionid=this.getCookie("sessionid");

        return Axios({
            method: "POST",
            url: config.API+'/'+path,
            data: data,
            headers: {
                "Content-Type": "application/json"
            },
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    async getData (path) {

        let session=this.getCookie("session");
        let userid=this.getCookie("userid");
        data.data.sessionid=this.getCookie("sessionid");

        return Axios({
            method: "GET",
            url: config.API+'/'+path+'/'+session+'/'+userid,
            headers: {
                "Content-Type": "application/json"
            },
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    async getProxy (path) {

        return Axios({
            method: "GET",
            url: config.API+'/'+path,
            headers: {
                "Content-Type": "application/json",
                "authorization": "test"
            },
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    async getDebug (path) {

        return Axios({
            method: "GET",
            url: config.API,
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    async getDebugHtml () {

        return Axios({
            method: "GET",
            url: config.API,
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    async getImageBuffer(filename) {
        let session = this.getCookie("session");
        let userid = this.getCookie("userid");
        let sessionid=this.getCookie("sessionid");
        
        return Axios({
            method: "GET",
            url: config.API + '/staging/' + filename,
            params: {
                token: session,
                userid: userid,
                sessionid: sessionid
            },
            responseType: 'arraybuffer',
            httpsAgent: (config.PRODUCTION ? new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    async postDataImage (data, progressBar) {
        data.data.session=this.getCookie("session");
        data.data.userid=this.getCookie("userid");
        data.data.user=this.getCookie("user");
        data.data.sessionid=this.getCookie("sessionid");

        if (progressBar!=null) {
            var progressText = progressBar.childNodes[0];

            return Axios({
                method: "POST",
                url: config.API+'/images/upload',
                data: data,
                headers: {
                    "Content-Type": "application/json"
                },
                httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null),
                onUploadProgress: function( progressEvent ) {
                    var uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                    if(progressBar){
                        progressBar.style = "width:"+uploadPercentage+"%"
                    }
                    if(progressText){
                        progressText.innerHTML = uploadPercentage+"%";
                    }
                }.bind(this)
            })
        }else {
            return Axios({
                method: "POST",
                url: config.API+'/images/upload',
                data: data,
                headers: {
                    "Content-Type": "application/json"
                },
                httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
            })
        }
    },
    getImage (data) {
        data.data.session=this.getCookie("session");
        data.data.userid=this.getCookie("userid");
        data.data.user=this.getCookie("user");
        data.data.sessionid=this.getCookie("sessionid");

        return Axios({
            method: "POST",
            url: config.API+'/images',
            data: data,
            headers: {
                "Content-Type": "application/json"
            },
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    getInvoice (data) {
        data.data.session=this.getCookie("session");
        data.data.userid=this.getCookie("userid");
        data.data.user=this.getCookie("user");
        data.data.sessionid=this.getCookie("sessionid");

        return Axios({
            method: "POST",
            url: config.API+'/invoices',
            data: data,
            headers: {
                "Content-Type": "application/json"
            },
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    getTechdoc (data) {
        data.data.session=this.getCookie("session");
        data.data.userid=this.getCookie("userid");
        data.data.user=this.getCookie("user");
        data.data.sessionid=this.getCookie("sessionid");

        return Axios({
            method: "POST",
            url: config.API+'/techdocs',
            data: data,
            headers: {
                "Content-Type": "application/json"
            },
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    getVesselpic (data) {
        data.data.session=this.getCookie("session");
        data.data.userid=this.getCookie("userid");
        data.data.user=this.getCookie("user");
        data.data.sessionid=this.getCookie("sessionid");

        return Axios({
            method: "POST",
            url: config.API+'/vesselpics',
            data: data,
            headers: {
                "Content-Type": "application/json"
            },
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    getInventoryPic (data) {
        data.data.session=this.getCookie("session");
        data.data.userid=this.getCookie("userid");
        data.data.user=this.getCookie("user");
        data.data.sessionid=this.getCookie("sessionid");

        return Axios({
            method: "POST",
            url: config.API+'/inventorypics',
            data: data,
            headers: {
                "Content-Type": "application/json"
            },
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    getFileDownload(data){
        data.data.session=this.getCookie("session");
        data.data.userid=this.getCookie("userid");
        data.data.user=this.getCookie("user");
        data.data.sessionid=this.getCookie("sessionid");

        return Axios({
            method: "POST",
            url: config.API+'/files',
            responseType: 'blob',
            data: data,
            headers: {
                "Content-Type": "application/json"
            },
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    getTroubleticketFileDownload(data){
        data.data.session=this.getCookie("session");
        data.data.userid=this.getCookie("userid");
        data.data.user=this.getCookie("user");
        data.data.sessionid=this.getCookie("sessionid");

        return Axios({
            method: "POST",
            url: config.API+'/troubleticketfiles',
            responseType: 'blob',
            data: data,
            headers: {
                "Content-Type": "application/json"
            },
            httpsAgent: (config.PRODUCTION?new https.Agent({ rejectUnauthorized: false }) : null)
        })
    },
    getMobileDownload(data, path) {
		data.data.session = this.getCookie("session");
		data.data.userid = this.getCookie("userid");
		data.data.user = this.getCookie("user");
		data.data.sessionid = this.getCookie("sessionid");
		
		return Axios({
			method: "POST",
			url: config.API + '/download/' + path,
			responseType: 'blob',
			data: data,
			headers: {
				"Content-Type": "application/json"
			},
			httpsAgent: (config.PRODUCTION ? new https.Agent({ rejectUnauthorized: false }) : null)
		});
	},
    getCookie(cname) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${cname}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    },
    eraseLogCookies(){
        this.eraseCookie("session");
        this.eraseCookie("userid");
        this.eraseCookie("user");
        this.eraseCookie("perms")
    },
    eraseCookie(cname){
        document.cookie=cname+"=;";
    },
    getPerms(){
        let string = this.getCookie("perms")
        if(string!=undefined){
            let array = string.split(",");
            return array;
        }
        return [];
    },
    async setColors(){
        //console.log(router.history.current.path)
        if(router.history.current.path == "/0207"){
            return;
        }
        var all = document.getElementsByTagName("*");
        var woNumbers = []
        var woNumberPos = []
        var woNumberStartIndex = []

        for (var i = 0; i < all.length; i++) {
            if(all[i].children.length==0){
                var domString = all[i].innerHTML;
                var regex = new RegExp(/(11-){1}\d{5}/g)
                var search = domString.match(regex);
                if(search!=null){
                    woNumbers.push(search[0])
                    woNumberPos.push(all[i]);
                    woNumberStartIndex.push(domString.search(regex));
                }
            }
        }

        if(woNumbers.length>0){
            this.postData(
                {
                    type:"search",
                    data:{
                        pageid:pages.WO_COLORS,
                        data:[
                            woNumbers
                        ],
                    }
                }
            ).then((res) => {

                //console.log("GETITING COLORS")
                var colorPos = 0;
                var data = res.data.data.column_data[colorPos]

                for(var i = 0;i<woNumbers.length;i++){
                    let nextData = res.data.data.column_data[colorPos+1]

                    if(nextData==null){
                        nextData='null';
                    }

                    if(data==null || data[3]!=woNumbers[i]){
                        if(nextData[3]!=woNumbers[i]){
                            //go backwards to check other wonumbers
                            let checkDataIndex = colorPos-1;
                            while(checkDataIndex > 0 && res.data.data.column_data[checkDataIndex][3]!=woNumbers[i]){
                                checkDataIndex--;
                            }
                            data = res.data.data.column_data[checkDataIndex];
                        }else{
                            colorPos++;
                            data = nextData;
                        }
                    }
                    if(data!=null){
                        var color = "#"+data[0];
                        var fontColor = "#"+data[4];

                        //woNumberPos[i].style.setProperty("background-color",color);
                        //woNumberPos[i].title = data[1]+", "+data[2];
                        let woStyle = "style='background-color:"+color+"; color:"+fontColor+";'";
                        let woTitle = "title='"+data[1]+", "+data[2]+"'";
                        let woHref = "href='/#/0301?q="+data[3]+"'";

                        if(woNumberPos[i].outerHTML.includes('href') || woNumberPos[i].parentNode.outerHTML.includes('href')){

                        }else{
                            var innerHTMLText =
                                woNumberPos[i].innerHTML.substr(0,woNumberStartIndex[i])+
                                "<a "+woStyle+" "+woTitle+" "+woHref+">"+data[3]+"</a>"+
                                woNumberPos[i].innerHTML.substr(woNumberStartIndex[i]+8,woNumberPos[i].innerHTML.length-8-woNumberStartIndex[i])

                            woNumberPos[i].innerHTML = innerHTMLText
                        }

                        currentColoredElements.push(woNumberPos[i]);
                    }

                }
            });
        }
    },
    async setWOColors(){
        var self = this
        setTimeout(function(){
            self.setColors()
        }, 100);
    },
    async clearWOColors(){
        for(var i = 0;i<currentColoredElements.length;i++){
            if(currentColoredElements[i]!=null){
                currentColoredElements[i].style.setProperty("background-color",'#00000000');
                currentColoredElements[i].removeAttribute('title');
            }
        }
        currentColoredElements = [];
    },
    decodeMIMEString(input) {
        return decodeMIMEString(input);
    }
}

function decodeMIMEString(input) {
    // Helper function to decode Base64
    function decodeBase64(base64String) {
        let byteString = atob(base64String);
        let byteArray = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            byteArray[i] = byteString.charCodeAt(i);
        }
        let decoder = new TextDecoder("utf-8");
        return decoder.decode(byteArray);
    }

    // Helper function to decode Quoted-Printable
    function decodeQuotedPrintable(qpString) {
        qpString = qpString.replace(/_/g, ' '); // Replace underscores with spaces
        qpString = qpString.replace(/=([0-9A-F]{2})/gi, function(match, p1) {
            return String.fromCharCode(parseInt(p1, 16));
        });
        let byteArray = new Uint8Array(qpString.length);
        for (let i = 0; i < qpString.length; i++) {
            byteArray[i] = qpString.charCodeAt(i);
        }
        let decoder = new TextDecoder("utf-8");
        return decoder.decode(byteArray);
    }

    // Regular expression to find MIME encoded words
    const mimeRegex = /=\?([^?]+)\?([BQ])\?([^?]+)\?=/gi;

    return input.replace(mimeRegex, (match, charset, encoding, encodedText) => {
        if (charset.toUpperCase() === 'UTF-8') {
            if (encoding.toUpperCase() === 'B') {
                return decodeBase64(encodedText);
            } else if (encoding.toUpperCase() === 'Q') {
                return decodeQuotedPrintable(encodedText);
            }
        }
        return match; // Return the original match if it doesn't match expected patterns
    });
}

function generateRandomString(length = 43) {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    let result = '';
    const randomValues = new Uint8Array(length);
    window.crypto.getRandomValues(randomValues);
    for (let i = 0; i < length; i++) {
    result += charset[randomValues[i] % charset.length];
    }
    return result;
}

async function pkceChallengeFromVerifier(verifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest("SHA-256", data);
    const base64 = btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
    return base64;
}

async function openKeycloakPopup() {
    const keycloakClientConfig = {
        clientId: "portal",
        realm: "master",
        url: "https://accounts.ldpa.com"
    };

    const redirectUri = `https://portal.ldpa.us/auth-callback`;
    const codeVerifier = generateRandomString();
    const codeChallenge = await pkceChallengeFromVerifier(codeVerifier);

    sessionStorage.setItem("pkce_code_verifier", codeVerifier);

    const authParams = new URLSearchParams({
        client_id: keycloakClientConfig.clientId,
        redirect_uri: redirectUri,
        response_type: "code",
        scope: "openid profile email roles",
        code_challenge: codeChallenge,
        code_challenge_method: "S256"
    });

    const authUrl = `${keycloakClientConfig.url}/realms/${keycloakClientConfig.realm}/protocol/openid-connect/auth?${authParams.toString()}`;

    const width = 600;
    const height = 700;
    const name = 'Keycloak Login';

    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    return window.open(
        authUrl,
        name,
        `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
    );
}
  
export { openKeycloakPopup };


// WEBPACK FOOTER //
// ./src/api.js